import React from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';

export interface SingleCardProps {
  title?: string;
  description?: string;
  titleStyle?: any;
}

export default function SingleCard({ title, description, children, titleStyle }: React.PropsWithChildren<SingleCardProps>) {
  return (
    <ScrollView height={'100%'} width={'100%'} className={'with-footer single-card'}>
      <div className={'dx-card content'}>
        <div className={'header'}>
          <div className={'title'} style={{ ...titleStyle }}>{title}</div>
          <div className={'description'}>{description}</div>
        </div>
        {children}
      </div>
    </ScrollView>
)}
